import { Box, Text, View } from "native-base";
import React, { useEffect, useMemo, useState } from "react";
import { useAppContext } from "../Universal/API/Context-API/AppContext";
import { webFont } from "../Universal/API/API";
import { UnitProps } from "./Components/Unit";
import { DeanteData } from "../Universal/API/Context-API/AppProvider";
import { ListOfUnitsV3 } from "./Components/V3";
import { useIsFocused } from "@react-navigation/native";
import HomeBannerCarousel, { HomeBannerSlide } from "./Components/HomeBannerCarousel";


interface HomeScreenProps {
    navigation: any, route: any
}

export const formUnits = ({ result, setUnits }: {
    result: DeanteData[],
    setUnits: (x: UnitProps['unit'][]) => any,
}) => {
    setUnits(
        result.map(res => formUnit(res))
    )
}

export const formUnit = (res: DeanteData) => {
    return ({
            description: `${res.fab} ${res.name}, ${res.poverh}`,
            price: `${res.price} р/${res.ed}`,
            url: `${res.uri_full}`,
            unit: res,
            discount: res.discount,
            discounted_price: `ОПТ ${res.discounted_price} р/${res.ed}`
        })
}

const HomeScreen: React.FC<HomeScreenProps> = ({ navigation, route }) => {
    const { scaleAll, isSmallVersion, allUnitData } = useAppContext()
    const isFocused = useIsFocused()

    const [lastUnits, setUnits] = useState<UnitProps['unit'][]>([]);

    useEffect(() => {
        if (allUnitData) {
            const result = Object.values(allUnitData).sort(
                (data, data2) => {
                    return parseInt(data2.id) - parseInt(data.id)
                }
            ).slice(30)

            formUnits({
                setUnits,
                result
            })
        }
    }, [allUnitData])

    const bannerSlides = useMemo<HomeBannerSlide[]>(
        () => [
            {
                image: `https://deante.pro/img/home/slider/BLUR_2048x576.jpg`,
                collectionName: "Blur",
            },
            {
                image: "https://deante.pro/img/home/slider/SILIA_2048x576.jpg",
                collectionName: "Silia",
            },
            {
                image: "https://deante.pro/img/home/slider/SILIA_SMART_2048x576.jpg",
                collectionName: "Silia",
            },
        ],
        []
    );

    const filteredUnits = useMemo(
        () => lastUnits.filter(x => x.unit.col == "Blur" || x.unit.col == "Silia Hexa"),
        [lastUnits]
    );

    const header = useMemo(
        () => (
            <>
                <HomeBannerCarousel
                    navigation={navigation}
                    slides={bannerSlides}
                    autoPlay={isFocused}
                />
                <View
                    style={{
                        marginLeft: (!isSmallVersion ? 35 : 20) * scaleAll,
                        marginTop: (!isSmallVersion ? 37 : 20) * scaleAll,
                    }}
                >
                    <Text
                        style={{
                            marginBottom: 10 * scaleAll,
                            fontFamily: webFont("Inter"),
                            fontSize: 18 * scaleAll,
                            color: "black",
                            fontWeight: "600",
                        }}
                    >
                        Новинки
                    </Text>
                </View>
            </>
        ),
        [bannerSlides, isFocused, isSmallVersion, navigation, scaleAll]
    );

    return (
        <>
            {/* <Helmet prioritizeSeoTags>
                  <title>Фабрика Deante — Керамическая плитка и керамогранит премиум-класса</title>
                <meta name="description" content="Фабрика Deante предлагает коллекции керамической плитки и керамогранита высокого качества. Эстетика, прочность и стиль для вашего интерьера." />
                <meta property="og:title" content="Фабрика Deante — Керамическая плитка и керамогранит премиум-класса" />
                <meta property="og:description" content="Откройте для себя коллекции плитки Deante: мрамор, бетон, камень и другие уникальные решения для вашего интерьера." />
                <meta property="og:url" content="https://deante.pro/" />
                <meta property="og:image" content="https://deante.pro/js/logo/main-banner.jpg" />
                <meta name="twitter:title" content="Фабрика Deante — Керамическая плитка и керамогранит премиум-класса" />
                <meta name="twitter:description" content="Плитка Deante: эстетика, прочность и стиль для вашего интерьера. Узнайте больше." />
            </Helmet> */}
            
            <Box flex={1} >
            {isFocused && <ListOfUnitsV3
                // marginHorizontal={(!isSmallVersion ? 35 : 20) * scaleAll}
                listOfUnis={filteredUnits}
                renderHeader={header}
                navigation={navigation}
                />}
                </Box>
        </>
    )
}

export default React.memo(HomeScreen);
